import React from 'react';
import { Layout } from './Header.styles';

const Header = ({ header }) => {
  return <Layout>{header}</Layout>;
};

export default Header;
